"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "GetParentObject", {
  enumerable: true,
  get: function get() {
    return _GetParentObject.default;
  }
});
Object.defineProperty(exports, "SVBHeader", {
  enumerable: true,
  get: function get() {
    return _SVBHeader.default;
  }
});
var _SVBHeader = _interopRequireDefault(require("./src/SVBHeader"));
var _GetParentObject = _interopRequireDefault(require("./src/helper/GetParentObject"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }